var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3051 17.1279H6.69547C5.76432 17.1279 4.99015 16.411 4.91873 15.4826L4.1543 5.54492H14.8463L14.0818 15.4826C14.0104 16.411 13.2362 17.1279 12.3051 17.1279V17.1279Z",
    stroke: "#FF2B2B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.836 5.54492H3.16406",
    stroke: "#FF2B2B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27234 2.87207H11.7273C12.2194 2.87207 12.6183 3.27098 12.6183 3.76307V5.54506H6.38135V3.76307C6.38135 3.27098 6.78026 2.87207 7.27234 2.87207Z",
    stroke: "#FF2B2B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M11.0591 9.10889V13.5639",
    stroke: "#FF2B2B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M7.94092 9.10889V13.5639",
    stroke: "#FF2B2B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicn);
export default __webpack_public_path__ + "static/media/deleteicn.f4767a833c5b8a4116c8195eca593578.svg";
export { ForwardRef as ReactComponent };